import { GraphQLResult } from '@aws-amplify/api-graphql';
import { useMutation } from '@tanstack/react-query';
import { API, graphqlOperation } from 'aws-amplify';
import {
  RenameMetadataMutation,
  RenameMetadataMutationVariables,
} from 'src/API';
import { renameMetadata } from 'src/graphql/mutations';
import { SuccessfulRenameResponse } from 'src/types';

const apiRenameEncoderMetadata = async (
  variables: RenameMetadataMutationVariables
): Promise<SuccessfulRenameResponse> => {
  const response = (await API.graphql(
    graphqlOperation(renameMetadata, variables)
  )) as GraphQLResult<RenameMetadataMutation>;

  const renameEncoderMetadataResponse = response.data?.renameMetadata;
  if (renameEncoderMetadataResponse?.status !== 200) {
    throw new Error(
      `Failed renameMetadata with status: ${renameEncoderMetadataResponse?.status}`
    );
  }

  if (!renameEncoderMetadataResponse.device) {
    throw new Error(
      `Failed renameMetadata with empty data ${renameEncoderMetadataResponse?.device}`
    );
  }
  return renameEncoderMetadataResponse as SuccessfulRenameResponse;
};

export const useEncoderMetadataRenaming = () => {
  const {
    mutate: renameEncoderMetadataMutation,
    mutateAsync: renameEncoderMetadataAsync,
    data: response,
    isSuccess,
    isError,
    isPending,
  } = useMutation({
    mutationFn: apiRenameEncoderMetadata,
  });

  return {
    renameEncoderMetadataMutation,
    renameEncoderMetadataAsync,
    response,
    isSuccess,
    isError,
    isPending,
  };
};
